import { getPaidBasePlan, getSubscriptionPrice } from '@/constants/utils/subscriptionPricing';

export const IOS_PREMIUM_PRODUCT_IDS = {
  PREMIUM_MONTHLY: 'ai.gab.gabaiapp.plus.premium.monthly',
  PREMIUM_YEARLY: 'ai.gab.gabaiapp.plus.premium.yearly',
};

export const CREDIT_PACK_CREDITS = [700, 2200, 5000, 11250, 31250];
export function getCreditPackIapProductId(credits) {
  if (credits == null) return null;
  const amount = Number(credits);
  return CREDIT_PACK_CREDITS.includes(amount) ? `ai.gab.gabaiapp.credits.${amount}` : null;
}

export function nativeCreditPackPrice(product) {
  return product?.localizedPrice || product?.oneTimePurchaseOfferDetails?.formattedPrice || null;
}

export function nativeValidationResult(response, productId) {
  const data = response?.data && typeof response.data === 'object' ? response.data : response;
  const expected = productId?.includes('.credits.') ? 'completed' : 'active';
  const status = data?.status || data?.purchaseStatus;
  if (status === expected && !response?.error && !data?.error) return { success: true, data };
  return { success: false, pending: !['failed', 'refunded', 'revoked', 'invalid'].includes(status), data,
    error: data?.message || response?.message || 'Your purchase is still being verified. Use Restore; do not purchase again.' };
}

export function nativeCheckoutResult(result) {
  if (result?.success || result?.cancelled) return result;
  const pending = Boolean(result?.pending ?? result?.charged);
  return { ...result, success: false, pending, pendingValidation: pending };
}

export function nativeSubscriptionPlans(products = [], platform) {
  return products.flatMap(product => {
    const phase = getPaidBasePlan(product)?.pricingPhases?.pricingPhaseList?.[0];
    const unit = product.subscriptionPeriodUnitIOS;
    const count = Number(product.subscriptionPeriodNumberIOS || 1);
    const cadence = platform === 'android'
      ? ({ P1W: 'weekly', P1M: 'monthly', P1Y: 'yearly' })[phase?.billingPeriod]
      : count === 1 ? ({ WEEK: 'weekly', MONTH: 'monthly', YEAR: 'yearly' })[unit]
        : unit === 'DAY' && count === 7 ? 'weekly' : null;
    const price = getSubscriptionPrice(product, platform);
    if (!cadence || !price) return [];
    const tier = platform === 'ios' && Object.values(IOS_PREMIUM_PRODUCT_IDS).includes(product.productId) ? 'premium' : 'plus';
    const planId = tier === 'premium' ? `premium-${cadence}` : cadence;
    return [{ productId: product.productId, cadence, price, tier, planId,
      label: `Plus${tier === 'premium' ? ' Premium' : ''} ${({ weekly: 'Weekly', monthly: 'Monthly', yearly: 'Annual' })[cadence]}`,
      period: ({ weekly: '/week', monthly: '/month', yearly: '/year' })[cadence] }];
  });
}

export function googleReplacementPurchase(purchases, subscriptionIds) {
  const subscriptions = (purchases || []).filter(p => subscriptionIds.includes(p.productId));
  if (subscriptions.some(p => p.purchaseStateAndroid === 2)) {
    throw new Error('A Google Play payment is pending. Complete or cancel it in Google Play before changing plans.');
  }
  const tokens = [...new Map(subscriptions.map(p => [p.purchaseToken, p])).values()];
  if (tokens.length > 1 || (tokens.length && !tokens[0].purchaseToken)) {
    throw new Error('Please manage your existing subscription in Google Play before changing plans.');
  }
  return tokens[0] || null;
}
